export enum UserFileNames {
  AVATAR = "avatarFile",
  COLLEGECARDFRONT = "collegeCardFrontFile",
  COLLEGECARDBACK = "collegeCardBackFile",
}
